import Vue from "vue";

const state = {
  clientSecret: null,
  paymentMethods: []
};

const getters = {};

const actions = {
  LOAD_PAYMENT_METHODS: async function({ commit, rootState }) {
    await Vue.prototype.$axios
      .get("/stripe/get-payment-methods/" + rootState.auth.user.uid)
      .then(res => {
        commit("SET_PAYMENT_METHODS", res.data.paymentMethods);
      });
  },
  SETUP_PAYMENT_INTENT: async function({ commit }) {
    await Vue.prototype.$axios
      .post("/stripe/setup-payment-intent")
      .then(res => {
        commit("SET_CLIENT_SECRET", res.data.setupIntent.client_secret);
      });
  },
  ATTACH_PAYMENT_METHOD: async function({ dispatch }, payload) {
    await Vue.prototype.$axios.post("/stripe/attach-payment-method/" + payload);
    dispatch("LOAD_PAYMENT_METHODS");
  },
  DELETE_PAYMENT_METHOD: async function({ dispatch }, payload) {
    await Vue.prototype.$axios.delete(
      "/stripe/delete-payment-method/" + payload
    );
    dispatch("LOAD_PAYMENT_METHODS");
  }
};

const mutations = {
  SET_CLIENT_SECRET: function(state, payload) {
    state.clientSecret = payload;
  },
  SET_PAYMENT_METHODS: function(state, payload) {
    state.paymentMethods = payload;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
